import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const page = ReactDOM.createRoot(document.getElementById('page'));
page.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
